import { makeVar } from '@apollo/client'

/**
 * True while a wallet is being connected and signed for linking (FE-305).
 * The Privy auto-selection pauses meanwhile: the wallet being linked is not
 * the user's yet, so it must not be swapped back for the Privy wallet.
 */
export const isWalletLinkingVar = makeVar(false)
